import { createSelector } from 'reselect';
import { getLatestWidgetData } from './getLatestWidgetData';
export const getEnableSdkCloseButton = createSelector(getLatestWidgetData, widgetData => widgetData.enableSdkCloseButton);